var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-wrapper',{attrs:{"loading":_vm.loading}},[_c('div',{staticClass:"space-y-4"},[_c('alert-message',{attrs:{"type":"info","message":"Yang akan masuk laporan bonus adalah cashbill yang sudah divalidasi kasir stockist"}}),_c('create-order-form',{attrs:{"use-origin-office-warehouse":"","with-destination-area":"","with-restock-type":false,"with-upline":""},model:{value:(_vm.order),callback:function ($$v) {_vm.order=$$v},expression:"order"}}),(_vm.order.destinationOffice.id)?[_c('create-order-detail-form',{attrs:{"order-id":_vm.order.id,"origin-office":{
          id: _vm.order.originOffice.id,
          code: _vm.order.originOffice.code,
        },"destination-office":{
          id: _vm.order.destinationOffice.id,
          code: _vm.order.destinationOffice.code,
        },"origin-warehouse":{
          id: _vm.order.originOffice.currentWarehouse.id,
          code: _vm.order.originOffice.currentWarehouse.code,
        },"buyer-type":_vm.order.buyerType,"area":_vm.order.area,"columns":[
          'code',
          'name',
          'point',
          'stock',
          'stock_free',
          'qty',
          'price',
          'total_price',
          'action',
          'total_weight',
          'point_value',
          'bonus_value',
        ],"total-price-label":"","create-order-attributes":{
          order_shipment: _vm.order.shipment_type,
          order_type: 'sale',
          destination_warehouse_id:
            _vm.order.destinationOffice.currentWarehouse.id,
          ...(_vm.order.custom_shipment_address
            ? {
                destination_address: {
                  province_id: _vm.order.shipmentAddress.province.id,
                  city_id: _vm.order.shipmentAddress.city.id,
                  district_id: _vm.order.shipmentAddress.district.id,
                  village_id: _vm.order.shipmentAddress.village.id,
                  address: _vm.order.shipmentAddress.address,
                },
              }
            : {}),
        }},on:{"order-created":_vm.onOrderCreated,"order-detail-updated":_vm.loadProductBundles},model:{value:(_vm.orderDetails),callback:function ($$v) {_vm.orderDetails=$$v},expression:"orderDetails"}}),(_vm.hasOrderDetail)?[(_vm.productBundles.length)?_c('order-promo-list',{attrs:{"order-details":_vm.orderDetailsForPromoList,"product-bundles":_vm.productBundles,"stocks":_vm.productBundlesBonusStocks,"warehouse-stocks":_vm.productBundlesBonusWarehouseStocks},on:{"change-selected-bundles":_vm.onChangeSelectedBundles,"change-choosen-bonuses":_vm.onChangeChoosenBonuses,"update-remainder-status":status => _vm.promoHasRemainder = status}}):_vm._e(),_c('create-order-summary',{attrs:{"order-details":_vm.orderDetails,"with-cashback":false,"payment-methods":_vm.paymentMethods,"with-tax":false},model:{value:(_vm.order),callback:function ($$v) {_vm.order=$$v},expression:"order"}}),_c('create-payment-form',{attrs:{"order-id":_vm.order.id,"payment-id":_vm.paymentId,"with-validate-button":false,"with-summary":false,"edc-input-bank":false,"sync":"","auto-save":""},model:{value:(_vm.paymentMethods),callback:function ($$v) {_vm.paymentMethods=$$v},expression:"paymentMethods"}}),_c('div',{staticClass:"grid grid-cols-1 sm:flex justify-end gap-2"},[_c('base-button',{attrs:{"disabled":!_vm.canValidate},on:{"click":function($event){_vm.visibleValidate = true}}},[_vm._v("Siap Validasi")]),_c('base-button',{attrs:{"color":"danger","to":{ name: 'transaksi-cashbill' }}},[_vm._v("Selesai")])],1)]:_vm._e()]:_vm._e(),_c('validate-order-confirmation',{attrs:{"order-id":_vm.order.id,"visible":_vm.visibleValidate,"validation-data":{
        selected_bundles_id: this.selectedBundes,
        choosen_bonuses: this.choosenBonuses
      }},on:{"close":function($event){_vm.visibleValidate = false},"confirmed":function($event){_vm.visibleDetail = true}}}),_c('view-order-modal',{attrs:{"label":"Cashbill","columns":[
        'code',
        'warehouse',
        'office',
        'date',
        'user',
        'area',
        'shipment_type',
        'address',
      ],"with-shipment":false,"with-bonus":"","visible":_vm.visibleDetail,"order-id":_vm.order.id},on:{"close":function($event){return _vm.$router.push({ name: 'transaksi-cashbill' })},"validated":function($event){return _vm.$router.push({ name: 'transaksi-cashbill' })}}})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }